module.exports = __webpack_public_path__ + "static/media/img404.da0f90fa.svg";